export default "__VITE_PUBLIC_ASSET__d31bc1c4__"